<template>
  <span></span>
</template>
<script>
export default {
  name: "url-parser",
  props: {
    selectComponentId: {
      type: String,
      required: true
    },
    sources:Array
  },
  methods: {
    updateValue (val) {
      this.$emit("component-updated", {
        text: val
      });
      this.$emit("input", val);
    }
  },
  mounted () {
    const found = this.sources.filter(source=>source.url === this.$route.fullPath)
    if(found.length>0){
      this.$store.dispatch("setComponentStatus", {
        component: this.selectComponentId,
        status: {
          selected: found[0]
        }
      });
      const page = found[0].redirect || 'home'
      this.goToPage(page,this)
    }

  }
};
</script>